import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";

export const GrowthLeaderboard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/referrals/leaderboard").then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data || !data.items.length) return null;

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 lg:px-8" data-testid="growth-leaderboard">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="font-display text-2xl font-extrabold text-primary sm:text-3xl">
            Ciftora'yı Büyütenler
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-muted-foreground">{data.note}</p>
        </div>
        <Link
          to="/panel/davet"
          data-testid="leaderboard-invite-cta"
          className="inline-flex h-11 items-center rounded-full bg-accent px-5 text-sm font-bold text-primary transition-colors hover:bg-accent/90"
        >
          Sen de davet et, kazan
        </Link>
      </div>

      <ol className="mt-6 grid gap-3 sm:grid-cols-2" data-testid="leaderboard-list">
        {data.items.map((u) => {
          const row = (
            <>
              <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-display text-sm font-extrabold ${
                u.rank <= 3 ? "bg-accent text-primary" : "bg-muted text-primary"}`}>
                {u.rank}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-bold text-primary">{u.name}</span>
                <span className="block truncate text-xs text-muted-foreground">
                  {u.province || "Türkiye"} · {u.count} davet ödülü
                </span>
              </span>
              {u.badge && (
                <span className="flex shrink-0 items-center gap-1 rounded-full bg-secondary/15 px-3 py-1 text-[11px] font-bold text-secondary">
                  <Trophy className="h-3 w-3" /> {u.badge}
                </span>
              )}
            </>
          );
          return (
            <li key={u.rank} data-testid={`leaderboard-row-${u.rank}`}>
              {u.slug ? (
                <Link to={`/satici/${u.slug}`} className="flex items-center gap-3 rounded-xl border border-border bg-card p-4 transition-colors hover:border-secondary">
                  {row}
                </Link>
              ) : (
                <div className="flex items-center gap-3 rounded-xl border border-border bg-card p-4">{row}</div>
              )}
            </li>
          );
        })}
      </ol>
    </section>
  );
};
